export const REDUX_APP_BASE = 'common';
